import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { ContactoClienteEdit } from "./edit";
const EditModal = ContactoClienteEdit;
type Entity = models.ContactoCliente;
export interface Props {
    value: Entity[];
    idDireccion?: number;
    onChange?: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
    label?: React.ReactNode;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>, readonly: boolean): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    const estaticas = [
        { title: "Nombre", cell: x => ({ data: x.Nombre }) },
        //{ title: "Telefono", cell: x => ({ data: x.Telefono }) },
        { title: "Email", cell: x => ({ data: x.Email }) } 
    ];

    return readonly ? estaticas : [botones, ...estaticas];
}

/**
* Listado de ContactoCliente
*/
class ContactoClienteListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, { idDireccion: this.props.idDireccion }, { Identificacion: {} } as Entity);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            if (this.props.onChange) {
                await this.props.onChange([...oldList, newItem]);
            }
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, { idDireccion: this.props.idDireccion }, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            if (this.props.onChange) {
                await this.props.onChange(oldList.map(x => x == item ? newItem : x));
            }
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.Nombre);
        if (ok) {
            const oldList = this.props.value;
            if (this.props.onChange) {
                await this.props.onChange(oldList.filter(x => x != item));
            }
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar }, !!this.props.readonly);
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>{this.props.label}</span>
                            {
                                !this.props.readonly &&
                                <div className="pull-right">
                                    <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                                </div>}
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const ContactoClienteList = kea.mapProps(componentToRx(ContactoClienteListNoRx), x => ({ ...x, value: x.value || [] }));   



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/contactos/list.tsx